import ApartmentLegend from './ApartmentLegend';

export default ApartmentLegend;
